import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import Inputer from "Utils/Helpers/Inputer";
import * as icons from 'react-bootstrap-icons';
import { useSetState } from "Utils/Helpers/Hooks";
import { setCreateNew } from '../../../../../Redux/slices/globalSlice';

export default function NewPatient({ reset, doReset }) {
    const dispatch = useDispatch();
    const { create_new } = useSelector((state) => ({
        create_new: state.setting.create_new,
    }));
    const [controls, setControls] = useSetState ({
        name: {
          id: "name",
          type: 'text',
          placeholder: 'نام و نام خانوادگی',
          value: '',
          icon: <icons.PersonSquare/>,
          force: true,
        },
        nCode: {
          id: "nCode",
          type: 'number',
          placeholder: 'کد ملی',
          value: '',
          icon: <icons.AppIndicator/>,
          force: false,
        },
        uniCode: {
          id: "uniCode",
          type: 'text',
          placeholder: 'شماره پرونده',
          value: '',
          icon: <icons.CardList/>,
          force: true,
        },
        mobile: {
          id: "mobile",
          type: 'number',
          placeholder: 'شماره موبایل',
          value: '',
          icon: <icons.Telephone/>,
          force: false,
        },
    });
    
    useEffect(() => {
        if(reset) {
            setControls({ name: { value: '' } });
            setControls({ nCode: { value: '' } });
            setControls({ uniCode: { value: '' } });
            setControls({ mobile: { value: '' } });
            doReset();
        }
    }, [reset])

    const setControlsValue = (name, value) => {
        setControls({ [name]: { value: value } });
        dispatch(setCreateNew({
            ...create_new,
            [name]: value,
        }))
    }
    
    return (
        <>
            <div className='flex-column-center-center w-100 px-2'>
                {
                    !reset && Object.keys(controls).map((key, index) => {
                        return (
                            <Inputer
                                key={`inputer_${controls[key].id}`}
                                id={controls[key].id}
                                type={controls[key].type}
                                placeholder={controls[key].placeholder}
                                value={controls[key].value}
                                setValue={setControlsValue.bind(this)}
                                force={controls[key].force}
                                icon={controls[key].icon}
                                className={'mb-2'}
                            />
                        )
                    })
                }
            </div>
        </>
    );
}
